import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRouteCheck, useUserContext } from 'shared/hooks'

import { FullPageAppTemplate } from '../../templates'
import styles from './TaskManagementApp.module.scss'

export const TaskManagementApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  const app = apps[AppId.TASK_MANAGEMENT]
  const isPublic = useRouteCheck('/public')

  return (
    <FullPageAppTemplate
      {...(isPublic
        ? { skipPermissionCheck: true }
        : { appId: AppId.TASK_MANAGEMENT })}
      className={styles.wrapper}
      scope='task_management'
      envKey={app?.runtimeEnvKey}
      entryPath='./TaskManagementApp'
      url={process.env.REACT_APP_TASKMANAGEMENT_APP_V2_DEV_PATH}
      appName={app?.name ?? 'Task Management'}
      appProps={{
        user,
        initialPath: app?.path ?? '/task-management',
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}
